export const SET_EVENT_LISTENER_HAS_BEEN_ATTACHED =
  "SET_EVENT_LISTENER_HAS_BEEN_ATTACHED";
export const SET_GOOD_DATA_EVENT = "SET_GOOD_DATA_EVENT";
export const SET_PLATFORM_INFO_EVENT = "SET_PLATFORM_INFO_EVENT";
export const SET_FILTER_VALUE_CHANGE_EVENT = "SET_FILTER_VALUE_CHANGE_EVENT";
export const SET_UI_DRILL_EVENT = "SET_UI_DRILL_EVENT";
export const SET_DATE_RANGE = "SET_DATE_RANGE";
export const SET_USER_BROWSER = "SET_USER_BROWSER";
